import React from 'react';

import PendingVersionLifecycleMessage from 'app/developer-v3/components/PendingVersionLifecycleMessage';
import { getNonEditableUiReason } from 'app/developer-v3/components/NonEditableUI';
import { CurrentVersionReadOnlyReason } from 'app/developer-v3/hooks';

function getLockedHints(userCount: number) {
  return {
    adminOnly: 'Admin access only',
    needAction: 'Create an Action to unlock this step.',
    needAuth: 'Set up Authentication to unlock this step.',
    needTrigger: 'Create a Trigger to unlock this step.',
    needValidation: 'Validate your integration to unlock this step.',
    productionOrUserCountExceeded: `This version of your integration ${getNonEditableUiReason(
      userCount
    )}, you have to create a new editable version by cloning your integration.`,
    validationError: 'Fix integration errors to unlock this step.',
    versionLifecyclePending: <PendingVersionLifecycleMessage />,
  };
}

function getReadOnlyReasons(
  currentVersionReadOnlyReason: CurrentVersionReadOnlyReason,
  userCount: number
) {
  const isReadOnly = !!currentVersionReadOnlyReason;
  const isLifecyclePending =
    currentVersionReadOnlyReason ===
    CurrentVersionReadOnlyReason.PENDING_VERSION_LIFECYCLE;
  const isNotAdmin =
    currentVersionReadOnlyReason === CurrentVersionReadOnlyReason.NOT_ADMIN;
  const isProduction =
    currentVersionReadOnlyReason === CurrentVersionReadOnlyReason.PRODUCTION;
  const isUserCountLimitExceeded =
    currentVersionReadOnlyReason ===
    CurrentVersionReadOnlyReason.USER_COUNT_LIMIT_EXCEEDED;

  const lockedHints = getLockedHints(userCount);

  const adminOnlyHint = isNotAdmin ? lockedHints.adminOnly : undefined;
  const lifecyclePendingHint = isLifecyclePending
    ? lockedHints.versionLifecyclePending
    : undefined;
  const productionOrUserCountLimitExceededHint =
    isProduction || isUserCountLimitExceeded
      ? lockedHints.productionOrUserCountExceeded
      : undefined;

  return {
    isReadOnly,
    isLifecyclePending,
    isNotAdmin,
    isProduction,
    isUserCountLimitExceeded,
    adminOnlyHint,
    lifecyclePendingHint,
    productionOrUserCountLimitExceededHint,
  };
}

export { getLockedHints, getReadOnlyReasons };
